import React, { useState } from 'react'
import NewMessage from './new-message'

export default function NewMessages({events, onClose, onShowGameModal}) {
  return <div className='new-messages-container'>
    {
      <div className='messages'>
        {events.map((event, index) => {
          return <NewMessage
            key={index}
            event={event}
            index={index}
            onClose={onClose}
            onShowGameModal={onShowGameModal}
          />
        })}
      </div>
    }
  </div>
}
